import * as React from "react";
import PropTypes from "prop-types";
import { Drawer } from "../../themeV2";
import { useActiveInfluencer } from "../../hooks";
import { NavigationRenderer, NavigationShopHeader } from "../../navigation";

const MobileSidebarModal = React.memo(function MobileSidebarModal({
  onClose = null,
}) {
  const activeInfluencer = useActiveInfluencer();
  const [open, setOpen] = React.useState(true);

  const handleOpenChange = React.useCallback(
    (nextOpen) => {
      setOpen(nextOpen);
      if (!nextOpen && onClose) onClose();
    },
    [onClose],
  );

  const handleLinkClick = React.useCallback(() => {
    setOpen(false);
    if (onClose) onClose();
  }, [onClose]);

  return (
    <Drawer.Root open={open} onOpenChange={handleOpenChange} side="left">
      <Drawer.Popup size="sm">
        <Drawer.Title className="sr-only">Navigation</Drawer.Title>
        {activeInfluencer && <NavigationShopHeader />}
        <NavigationRenderer context="mobile" onLinkClick={handleLinkClick} />
      </Drawer.Popup>
    </Drawer.Root>
  );
});

MobileSidebarModal.propTypes = {
  onClose: PropTypes.func,
};

export default MobileSidebarModal;
